import React, { useState, useEffect } from 'react';

const PwaInstaller = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [installable, setInstallable] = useState(false);

  // Detect PWA installation state
  useEffect(() => {
    const checkInstalled = () => {
      setIsInstalled(window.matchMedia('(display-mode: standalone)').matches);
    };

    checkInstalled();
    window.addEventListener('appinstalled', checkInstalled);
    return () => window.removeEventListener('appinstalled', checkInstalled);
  }, []);

  // Handle installation prompt events
  useEffect(() => {
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setInstallable(true); // The app can be installed
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  // Trigger installation
  const handleInstall = async (e) => {
    e.preventDefault();

    if (isInstalled || !installable) {
      return;
    }

    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
        setIsInstalled(true);
      }
      return;
    }

    // Fallback instructions
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    if (isIOS) {
      alert('To install this app, tap the Share button and then "Add to Home Screen".');
    } else {
      alert('To install this app, follow the instructions for your browser or device.');
      window.open('https://support.google.com/chrome/answer/9658361', '_blank');
    }
  };

  // Render based on the installation state and device capabilities
  const renderContent = () => {
    if (isInstalled) {
      return (
        <div style={{ textAlign: 'center', padding: '20px', color: '#00563B' }}>
          <p>New Life Covenant Church app is already installed.</p>
        </div>
      );
    }

    if (!installable) {
      return (
        <div style={{ textAlign: 'center', padding: '20px', color: '#00563B' }}>
          <h3>New Life Covenant Church</h3>
          <p>
            To install this app, please use a supported browser on a mobile device.
          </p>
          <p>
            <strong>For iOS:</strong> Open this page in Safari, tap the Share button, and select "Add to Home Screen."
          </p>
          <p>
            <strong>For Android:</strong> Follow the instructions in your browser to add this app to your home screen.
          </p>
        </div>
      );
    }

    return (
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)', // Adjust for exact center
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        width: '90%',
        // maxWidth: '300px',
        color: '#00563B'
      }}>
        <div style={{justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
          <img src="../nlcc-logo.png" height="50px" width="120px" alt="NLCC Logo" />
        </div>
        <h3 style={{ marginBottom: '10px' }}>New Life Covenant Church</h3>
        <p style={{ marginBottom: '10px', color: '#000000', textAlign: 'justify' }}>
          Click the buttton below to install Jabula NLCC mobile application.
        </p>
        <button
          onClick={handleInstall}
          style={{
            padding: '12px 24px',
            backgroundColor: '#00563B',
            color: 'white',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            width: '100%'
          }}
          aria-label="Install application"
        >
          Install App
        </button>
      </div>
    );
  };

  return renderContent();
};

export default PwaInstaller;